import { createNotification, fetch, key, trans } from "../../../lib/utils";
import React from "react";
import { Component } from "react";
import { Form } from "@formio/react";
import { FormBuilder } from "@formio/react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import { FeatureToGeoJSON } from "../../../lib/featureUtils";
import store from "../../../stores/store";
import { getLayerById } from "../../map/mapUtils";

class Formio extends Component {
  constructor(props) {
    super(props);

    this.submitForm = this.submitForm.bind(this);
    this.loginForm = this.loginForm.bind(this);
    this.login = this.login.bind(this);
    this.getForm = this.getForm.bind(this);
    this.getSubmissionData = this.getSubmissionData.bind(this);
    this.createForm = this.createForm.bind(this);

    this.state = {
      loaded: false,
      submissionData: null,
      username: store.getState().forms.selectedFormObject?.username,
      selectedForm: store.getState().forms.selectedForm,
      selectedLayer: store.getState().forms.selectedLayer,
      selectedFeature: store.getState().forms.selectedFeature,
      selectedSubmission: store.getState().forms.selectedSubmission,
      featureProperty:
        store.getState().forms.selectedFormObject?.configuration
          ?.featureProperty,
      northProperty:
        store.getState().forms.selectedFormObject?.configuration?.northProperty,
      southProperty:
        store.getState().forms.selectedFormObject?.configuration?.southProperty,
      westProperty:
        store.getState().forms.selectedFormObject?.configuration?.westProperty,
      eastProperty:
        store.getState().forms.selectedFormObject?.configuration?.eastProperty,
      password: null,
      formio: {
        url: store.getState().forms.selectedFormObject.configuration.url,
      },
      edit: false,
      authentication:
        store.getState().forms.selectedFormObject.authentication?.url,
      loggedin: store.getState().forms.selectedFormObject?.token ? true : false,
      token: store.getState().forms.selectedFormObject?.token,
    };
  }

  componentDidMount() {
    this.getForm();

    if (this.state.loggedin && this.state.authentication) {
      if (!store.getState().forms.showNewButtons) {
        store.dispatch({
          type: "forms/showNewButtons",
          payload: true,
        });
      }
    }

    if (this.state.selectedSubmission) {
      this.getSubmissionData();
    } else {
      this.setState({ edit: true });
    }
  }

  getSubmissionData() {
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=formio&contenttype=".concat(
          "application/json",
          "&url=",
          this.state.formio.url,
          "/submission/",
          this.state.selectedSubmission
        )
      ),
      "GET",
      { "x-jwt-token": this.state.token },
      null,
      (resp) => {
        _this.setState({ submissionData: { ...resp.data.data }, edit: true });
      }
    );
  }

  getForm() {
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=formio&contenttype=".concat(
          "application/json",
          "&url=",
          this.state.formio.url
        )
      ),
      "GET",
      { "x-jwt-token": this.state.token },
      null,
      (resp) => {
        _this.setState({ loaded: true, form: resp.data });
      }
    );
  }

  login(submission) {
    let _this = this;
    fetch(
      window["appConfig"]()["api"](
        "?proxy=formio&contenttype=".concat(
          "application/json",
          "&url=",
          this.state.authentication
        )
      ),
      "POST",
      {},
      {
        data: {
          email: submission.data.email,
          password: submission.data.password,
        },
      },
      (resp) => {
        if (resp.headers) {
          if (resp.headers["x-jwt-token"]) {
            store.dispatch({
              type: "forms/update",
              payload: {
                form: _this.state.selectedForm,
                property: "token",
                value: resp.headers["x-jwt-token"],
              },
            });

            store.dispatch({
              type: "forms/update",
              payload: {
                form: _this.state.selectedForm,
                property: "username",
                value: submission.data.email,
              },
            });

            store.dispatch({
              type: "forms/showNewButtons",
              payload: true,
            });

            store.dispatch({
              type: "forms/update/editMode",
              payload: "new",
            });

            _this.setState({
              token: resp.headers["x-jwt-token"],
              loggedin: true,
              username: submission.data.email,
            });
          }
        }
      }
    );
  }

  submitForm(e) {
    let _this = this;

    let postData = e.data;

    if (this.state.featureProperty) {
      try {
        // let _feature = store.getState().forms.selectedFeature;
        // postData[this.state.featureProperty] = JSON.stringify(
        //   FeatureToGeoJSON(_feature)
        // );

        let _features = new Array();

        getLayerById(this.props.selectedLayer)
          .getSource()
          .getFeatures()
          .forEach((feature) => {
            console.log(feature);

            if (
              feature
                .getId()
                .startsWith("group_" + this.props.currentFormFeatureGroupId)
            ) {
              let nsweSplit = feature.getId().split("_");

              switch (nsweSplit[nsweSplit.length - 1]) {
                case "north":
                  postData[this.state.northProperty] = feature
                    .getGeometry()
                    .getCoordinates()
                    .join(",");

                  break;

                case "south":
                  postData[this.state.southProperty] = feature
                    .getGeometry()
                    .getCoordinates()
                    .join(",");
                  break;

                case "east":
                  postData[this.state.eastProperty] = feature
                    .getGeometry()
                    .getCoordinates()
                    .join(",");
                  break;

                case "west":
                  postData[this.state.westProperty] = feature
                    .getGeometry()
                    .getCoordinates()
                    .join(",");
                  break;
              }

              _features.push(FeatureToGeoJSON(feature));
            }
          });

        postData[this.state.featureProperty] = JSON.stringify(_features);
      } catch (e) {}
    } else {
      postData[this.state.featureProperty] = "";
    }

    postData["email"] = this.state.username;

    let _submission = "";

    if (this.state.selectedSubmission) {
      _submission = this.state.selectedSubmission;
    }

    fetch(
      window["appConfig"]()["api"](
        "formiodb.php?url=".concat(
          this.state.formio.url,
          "submission/",
          _submission
        )
      ),
      this.state.selectedSubmission ? "PUT" : "POST",
      { "x-jwt-token": this.state.token },
      { data: e.data },
      (resp) => {
        let formData = { ...e.data };

        if (this.state.featureProperty) {
          delete formData[this.state.featureProperty];
        }

        // if (this.props.selectedFeature) {
        _this.props.saveAction(formData);
        //}

        createNotification({
          type: "success",
          message: trans("Form has been saved!"),
        });

        // fetch(
        //   window["appConfig"]()["api"]("formiodb.php"),
        //   "POST",
        //   {},
        //   { data: postData },
        //   (resp) => {
        //     console.log(resp);
        //   }
        // );

        _this.setState({
          loaded: false,
          // form: resp.data,
          submissionData: { ...resp.data.data },
          edit: false,
        });

        _this.getForm();
      }
    );
  }

  loginForm() {
    return (
      <div className="mt-2 p-2 me-3">
        <div className="ps-2 mt-2 color-get-blue strong border-bottom d-block pb-2">
          {trans("Login")}
        </div>

        <Form
          form={{
            title: "Login",
            display: "form",
            components: [
              {
                label: trans("Username"),
                key: "email",
                type: "email",
              },
              {
                label: trans("Password"),
                key: "password",
                type: "password",
              },
              {
                label: trans("Login"),
                key: "submit",
                type: "button",
                action: "submit",
                customClass: "btn btn-sm text-white ms-0",
              },
            ],
          }}
          onSubmit={this.login}
        />
        {/* <input
          type="text"
          className="form-control"
          placeholder={trans("Username")}
          value={this.state.username}
          onChange={(e) => {
            this.setState({ username: e.target.value });
          }}
        ></input>
        <input
          type="password"
          className="form-control mt-2"
          placeholder={trans("Password")}
          value={this.state.password}
          onChange={(e) => {
            this.setState({ password: e.target.value });
          }}
        ></input>
        <div className="mt-2">
          <button
            type="button"
            className="btn btn-sm btn-secondary text-white me-2"
            onClick={() => {
              this.setState({ username: null, password: null });
            }}
          >
            {trans("Clear")}
          </button>
          <button
            type="button"
            className="btn btn-sm btn-primary text-white"
            onClick={this.login}
          >
            {trans("Login")}
          </button> 
        </div>*/}
      </div>
    );
  }

  createForm() {
    switch (true) {
      case store.getState().forms.selectedFormObject?.authentication?.url &&
        !this.state.loggedin:
        return this.loginForm();
        break;

      case store.getState().forms.editMode === "new" ||
        store.getState().forms.editMode === "edit":
        return (
          <Form
            form={this.state.form}
            onSubmit={this.submitForm}
            onChange={(e) => {
              console.log(e);
              if (
                store.getState().forms.selectedFormObject
                  ?.geometryTypes?.[0] === "custom"
              ) {
                if (e?.changed?.component?.action === "custom") {
                  if (!window["formsPointDraw"]) {
                    this.props.formsDrawFeature("Point", (event) => {
                      event.feature.setProperties({
                        question: e.changed.component.key,
                      });
                    });
                  }
                }
              }
              this.setState({ submissionData: e.data });
            }}
            submission={{
              data: this.state.submissionData,
            }}
          />
        );
        break;

      default:
        return (
          <Form
            form={this.state.form}
            onSubmit={this.submitForm}
            onChange={(e) => {
              this.setState({ submissionData: e.data });
            }}
            submission={{
              data: this.state.submissionData,
            }}
          />
        );
        break;
    }
  }

  render() {
    if (this.state.loaded) {
      let _this = this;
      return (
        <div className="mt-2 p-2 me-3">
          <div className="mt-2">{this.createForm()}</div>
        </div>
      );
    }
    return (
      <span className="badge bg-info text-primary m-1 p-2">
        {trans("Please wait to load the form")}
      </span>
    );
  }
}

export default Formio;
